<template>
  <div
    v-loading="loadingAllDataRequired"
    element-loading-text="Cargando..."
    element-loading-background="rgba(255, 255, 255)"
  >
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane :label="$t('Tareas')" class="paddingBody content">
        <CompShowPage
          v-if="contract != null && inventory != null"
          :inventory="inventory"
          :workflows="workflows"
          :contractPeople="contractPeople"
          :contract="contract"
        />
        <br />
      </el-tab-pane>
      <el-tab-pane :label="$t('Contrato')" class="paddingBody">
        <MostrarContrato
          :key="forceRender"
          ref="viewContract"
          v-if="contract"
          :contract="contract"
          :fatherArea="fatherArea"
          :area="area"
          :workflows="workflows"
          :peopleContract="usersFaena"
        />
      </el-tab-pane>
      <el-tab-pane label="Pendientes" class="paddingBody">
        <CompShowPage
          v-if="contract != null && inventory != null"
          :inventory="inventory"
          :contract="contract"
          :workflows="workflows"
          :contractPeople="contractPeople"
          :filtro_usuario_riesgo="true"
        />
      </el-tab-pane>
      <el-tab-pane class="paddingBody" :label="$t('Vista Inventario')">
        <el-table
          :header-cell-style="function () { return 'background-color: rgb(7, 116, 141); color: white; padding: 0px;'}"
          border
          stripe
          :data="viewTableInventory"
          style="width: 100%;"
          height="800"
        >
          <el-table-column label="Paso del Proceso">
            <template slot-scope="scope">{{scope.row.tarea || "---"}}</template>
          </el-table-column>
          <el-table-column label="Evento Top">
            <template slot-scope="scope">{{scope.row.evento_top || "---"}}</template>
          </el-table-column>
          <el-table-column label="Peligro">
            <template slot-scope="scope">{{scope.row.peligro || "---"}}</template>
          </el-table-column>
          <el-table-column label="Energía">
            <template slot-scope="scope">{{scope.row.energia || "---"}}</template>
          </el-table-column>
          <el-table-column label="Evento no deseado">
            <template slot-scope="scope">{{scope.row.evento_no_deseado || "---"}}</template>
          </el-table-column>
          <el-table-column label="Nivel de riesgo Sin Control" align="center">
            <template slot-scope="scope">{{scope.row.nivel_riesgo_sin_control || "---"}}</template>
          </el-table-column>
          <el-table-column label="Controles existentes">
            <template slot-scope="scope">{{scope.row.controles || "---"}}</template>
          </el-table-column>
          <el-table-column label="Jerarquía de Control">
            <template slot-scope="scope">{{scope.row.jerarquia_control || "---"}}</template>
          </el-table-column>
          <el-table-column label="Evaluación con controles" align="center">
            <el-table-column label="Probabilidad" align="center">
              <template slot-scope="scope">{{scope.row.probabilidad || "---"}}</template>
            </el-table-column>
            <el-table-column label="Consecuencia" align="center">
              <template slot-scope="scope">{{scope.row.consecuencia || "---"}}</template>
            </el-table-column>
            <el-table-column label="Clasificación del Riesgo">
              <template slot-scope="scope">{{scope.row.tipo || "---"}}</template>
            </el-table-column>
            <el-table-column label="Controles Adicionales">
              <template slot-scope="scope">{{scope.row.control_adicional || "---"}}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Administración" align="center">
            <el-table-column label="Responsable de Verificar los Controles">
              <template slot-scope="scope">{{scope.row.responsable_control || "---"}}</template>
            </el-table-column>
            <el-table-column label="Frecuencia">
              <template slot-scope="scope">{{scope.row.frecuencia || "---"}}</template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template slot="title">
        <center>
          <span style="font-size: 14px;">PARA CONTINUAR DEBES INICIAR SESIÓN</span>
          <p
            style="font-size: 12px; color: #dd6f2a;"
          >Ingresa con tus credenciales para realizar la evaluación de riesgos</p>
        </center>
      </template>
      <div
        v-loading="loadingLogin"
        :element-loading-text="loading_desc"
        element-loading-background="rgba(255, 255, 255)"
      >
        <el-form :model="credentials" status-icon ref="formLogin">
          <el-form-item prop="rut" label="Nombre de usuario / RUT">
            <el-input :placeholder="$t('Ingrese RUT')" v-model="credentials.rut"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="Contraseña" style="margin-bottom: 0px;">
            <el-input
              type="password"
              :placeholder="$t('Ingrese contraseña')"
              @keyup.native.enter="submit"
              v-model="credentials.password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div v-if="errors.length > 0">
          <br />
          <br />
          <center>
            <li style="color: red; list-style:none;" v-for="error in errors" :key="error">
              <b>{{error}}</b>
            </li>
          </center>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!loadingLogin">
        <el-button type="primary" @click="submit">Aceptar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import moment from "moment";
import inventoryRequirements from "@/mixins/inventoryRequirements";
import CompShowPage from "@/components/C_ShowPage.vue";
import MostrarContrato from "@/components/MostrarContrato.vue";

export default {
  mixins: [inventoryRequirements],
  components: {
    CompShowPage,
    MostrarContrato
  },
  data() {
    return {
      loadingLogin: false,
      loading_desc: "",
      errors: [],
      dialogVisible: false,
      credentials: {
        rut: "",
        password: ""
      },
      workflows: [],
      viewTableInventory: [],
      forceRender: 0,
      contract: {},
      ready: false,
      auxStatus: {
        0: { text: "Borrador", colorClass: "gray" },
        1: { text: "Revisión", colorClass: "yellow" },
        2: { text: "Aprobado", colorClass: "green" },
        3: { text: "Importado Borrador", colorClass: "gray" }
      }
    };
  },

  created() {
    this.setTitle(this.$t("Inventario de riesgos"));
    if (this.$store.getters.isLoggedIn === false) {
      this.dialogVisible = true;
    } else {
      this.ready = true;
      // await this.getUsersFaena(this.$store.getters.role.faena_id);
      this.getAreasFaena();
      this.getEmpresasFaena();
      this.getWorkflow();
    }
  },
  watch: {
    "$store.getters.inventario": {
      handler(after, before) {
        if (Object.keys(after).lenght) {
          this.inventory = this.$store.getters.inventario;
        }
      },
      deep: true
    },
    inventory: function(newVal, oldVal) {
      this.tableInventory();
    },
    "$store.getters.actualContract": {
      handler(after, before) {
        this.contract = after;
      },
      deep: true
    },
    contract: {
      handler() {
        if (this.contract && this.contract.nombre) {
          this.setSubTitle(`${this.$t("Contrato")}: ${this.contract.nombre}`);
        }
        this.forceRender = this.forceRender + 1;
      }
    }
  },
  methods: {
    ...mapActions([
      "setTitle",
      "setSubTitle",
      "getUsersFaena",
      "getAreasFaena",
      "getEmpresasFaena"
    ]),
    tableInventory() {
      this.viewTableInventory = [];
      this.inventory.tareas.forEach(t => {
        if (t.riesgos) {
          t.riesgos.forEach(r => {
            if (r.causas && r.causas.length > 0) {
              r.causas.forEach(causa => {
                if (
                  causa.controles_preventivos &&
                  causa.controles_preventivos.length > 0
                ) {
                  causa.controles_preventivos.forEach(cp => {
                    this.viewTableInventory.push({
                      id: t._id,
                      tarea: t.nombre,
                      evento_top: r.nombre,
                      peligro: r.peligro ? r.peligro : "",
                      energia: r.energia ? r.energia : "",
                      evento_no_deseado: r.evento_no_deseado
                        ? r.evento_no_deseado
                        : "",
                      nivel_riesgo_sin_control: r.sin_controles
                        ? r.sin_controles.severidad
                        : "",
                      controles: cp.nombre,
                      jerarquia_control: cp.jerarquiaControl,
                      probabilidad: r.con_controles
                        ? r.con_controles.probabilidad
                        : "",
                      consecuencia: r.con_controles
                        ? r.con_controles.severidad
                        : "",
                      tipo: r.tipo,
                      control_adicional: r.control_adicional,
                      responsable_control: cp.responsable,
                      frecuencia: cp.frecuencia
                    });
                  });
                }
              });
            } else {
              this.viewTableInventory.push({
                id: t._id,
                tarea: t.nombre,
                evento_top: r.nombre,
                peligro: r.peligro ? r.peligro : "",
                energia: r.energia ? r.energia : "",
                evento_no_deseado: r.evento_no_deseado
                  ? r.evento_no_deseado
                  : "",
                nivel_riesgo_sin_control: r.sin_controles
                  ? r.sin_controles.severidad
                  : "",
                controles: "",
                jerarquia_control: "",
                probabilidad: r.con_controles
                  ? r.con_controles.probabilidad
                  : "",
                consecuencia: r.con_controles ? r.con_controles.severidad : "",
                tipo: r.tipo,
                control_adicional: r.control_adicional,
                responsable_control: "",
                frecuencia: ""
              });
            }
          });
        } else {
          this.viewTableInventory.push({
            id: t._id,
            tarea: t.nombre,
            evento_top: "",
            peligro: "",
            energia: "",
            evento_no_deseado: "",
            nivel_riesgo_sin_control: "",
            controles: "",
            jerarquia_control: "",
            probabilidad: "",
            consecuencia: "",
            tipo: "",
            control_adicional: "",
            responsable_control: "",
            frecuencia: ""
          });
        }
      });
    },
    getUrlVars() {
      var vars = [],
        hash;
      var hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    async submit() {
      this.errors = [];
      this.loadingLogin = true;
      this.loading_desc = "";
      var self = this;
      this.$refs.formLogin.validate(async valid => {
        if (valid) {
          const response = await this.$store.dispatch("login", this.credentials);
          if (!response.success) {
            this.errors.push(response.error);
            this.loadingLogin = false;
            return;
          }

          var params = this.getUrlVars();
          var my_role = params["rol"];
          var id_contrato = window.location.pathname.substring(15, 39);

          this.resetInventory();
          // Obtener Contrato
          this.loading_desc = "OBTENIENDO CONTRATO ...";
          await this.getContract(id_contrato);
          this.$store.dispatch("setSubTitle", this.$t(`Contrato: ${this.contract.nombre}`));

          this.loading_desc = "CONFIGURANDO ROLES ...";
          await this.$store.dispatch("getRoles");
          var newRole = null;
          if (this.$store.getters.user.admin) {
            newRole = {
              faena_id: this.contract.faena_id,
              admin: true
            };
          } else {
            newRole = {
              faena_id: this.contract.faena_id
            };
          }
          this.loading_desc = "OBTENIENDO ÁREAS ...";
          // Obtener áreas
          if (this.$store.getters.areas.length === 0) {
            // no hay store de areas
            await this.getContractArea(this.contract.area_id);
            if (this.area && this.area.area_padre_id) {
              await this.getContractFatherArea(this.area.area_padre_id);
            } // if
          } else {
            this.area = findArea(this.contract.area_id);
            this.fatherArea = findArea(this.area.area_padre_id);
          } // if
          // Area
          newRole.area_id = this.area._id;
          // Role
          newRole.role = my_role;
          // reset datos de otros roles
          await this.$store.dispatch("resetEmpresasFaena");
          await this.$store.dispatch("resetAreas");
          await this.$store.dispatch("resetContract");
          await this.$store.dispatch("resetUserContractByRole");
          await this.$store.dispatch("setRole", newRole);
          let permitido = false;
          if (this.$store.getters.user.admin) {
            permitido = true;
          }
          if (
            this.contract.revisores[my_role] &&
            this.contract.revisores[my_role].includes(this.$store.getters.user._id)
          ) {
            permitido = true;
          }
          if (my_role === "manager") {
            if (this.area.manager_id === this.$store.getters.user._id) {
              permitido = true;
            }
            if (this.fatherArea.manager_id === this.$store.getters.user._id) {
              permitido = true;
            }
          }
          if (my_role === "super") {
            if (this.area.super_id === this.$store.getters.user._id) {
              permitido = true;
            }
            if (this.fatherArea.super_id === this.$store.getters.user._id) {
              permitido = true;
            }
          }

          if (permitido === true) {
            var can_access_role = false;
            var mi_permiso = this.$store.getters.roles.filter(function(el) {
              return el.faena_id <= self.contract.faena_id;
            });

            if (this.fatherArea.manager_id === this.$store.getters.user._id) {
              can_access_role = true;
            }

            if (this.fatherArea.super_id === this.$store.getters.user._id) {
              can_access_role = true;
            }

            await mi_permiso.forEach(async p => {
              if (p.data && p.data.admin === true) {
                can_access_role = true;
              }
              if (
                p.data.areas &&
                p.data.areas[this.contract.area_id] &&
                p.data.areas[this.contract.area_id].includes(my_role)
              ) {
                can_access_role = true;
              }
              if (
                p.data.empresas &&
                p.data.empresas[this.contract.empresa_id] &&
                p.data.empresas[this.contract.empresa_id].includes(my_role)
              ) {
                can_access_role = true;
              }
              if (
                p.data.areas &&
                p.data.areas["GeneralAreasRoles"] &&
                p.data.areas["GeneralAreasRoles"].includes(my_role)
              ) {
                can_access_role = true;
              }
            });

            if (can_access_role === true) {
              this.loading_desc = "OBTENIENDO WORKFLOWS ...";
              // Obtener Workflows
              await this.getWorkflow();
              this.loading_desc = "OBTENIENDO PARTICIPANTES DEL CONTRATO ...";
              // Obtener personas del contrato
              await this.getUsersFaena(this.$store.getters.role.faena_id);
              this.contractPeople = this.usersFaena;
              this.loading_desc = "OBTENIENDO INVENTARIO ...";
              // Obtener inventario
              await this.getInventory();
              if (this.$store.getters.allcontractsUser.length === 0) {
                await this.$store.dispatch("getAllContractsFaena", this.contract.faena_id);
              }
              if (this.$store.getters.empresas.length === 0) {
                await this.$store.dispatch("getEmpresasByFaena", this.contract.faena_id);
              }
              this.loading_desc = "OBTENIENDO FAENAS ...";
              if (this.$store.getters.faenas.length === 0) {
                await this.$store.dispatch("getFaenas");
              }
              if (this.$store.getters.areas.length === 0) {
                await this.$store.dispatch("getAreasbyFaena", this.contract.faena_id);
              }
              this.loadingLogin = false;
              this.dialogVisible = false;
            } else {
              this.loadingLogin = false;
              this.errors.push("USUARIO NO POSEE LOS PERMISOS PARA REVISAR");
              await this.$store.dispatch("resetEmpresasFaena");
              await this.$store.dispatch("resetAreas");
              await this.$store.dispatch("resetContract");
              await this.$store.dispatch("resetUserAllContracts");
              await this.$store.dispatch("resetUserContractByRole");
              await this.$store.dispatch("latestState", null);
              await this.$store.dispatch("logout");
            }
          } else {
            this.loadingLogin = false;
            this.errors.push(
              "USUARIO NO PERTENECE AL CONTRATO O TIENE UN ROL DIFERENTE AL REQUERIDO"
            );
            await this.$store.dispatch("resetEmpresasFaena");
            await this.$store.dispatch("resetAreas");
            await this.$store.dispatch("resetContract");
            await this.$store.dispatch("resetUserAllContracts");
            await this.$store.dispatch("resetUserContractByRole");
            await this.$store.dispatch("latestState", null);
            await this.$store.dispatch("logout");
          }
        } else {
          this.loadingLogin = false;
        }
      });
    },
    getWorkflow() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      axios
        .get("/workflow/", config)
        .then(response => {
          this.workflows = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    goBack() {
      window.history.go(-1);
    },
    isActiveContract() {
      if (this.contract.tipo_contrato == "Propio") return true;
      return moment(this.contract.fecha_fin) - new Date() >= 0;
    },
    inventoryStatusText() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].text
        : this.$t("No Iniciado");
    },
    inventoryStatusColor() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].colorClass
        : "gray";
    }
  }
};
</script>

<style scoped>
.content {
  min-height: 50vh;
}
</style>
